import { NO_MATCH, DEFAULT_MATCH, POSITIVE_MATCH, NEGATIVE_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkUnit(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.hasUnit) {
    return NO_MATCH;
  }

  if (!("unitNode" in node)) {
    return NO_MATCH;
  }

  if (nodeCondition.hasUnit === "present") {
    return node.unitNode ? POSITIVE_MATCH : NEGATIVE_MATCH;
  }

  if (nodeCondition.hasUnit === "none") {
    return !node.unitNode ? POSITIVE_MATCH : NEGATIVE_MATCH;
  }

  if (nodeCondition.hasUnit?.includes(node.unitNode?.placement ?? "")) {
    return POSITIVE_MATCH;
  }

  if (nodeCondition.hasUnit?.includes(`not:${node.unitNode?.placement ?? ""}`)) {
    return NEGATIVE_MATCH;
  }

  const hasOnlyNegativeConditions =
    Array.isArray(nodeCondition.hasUnit) &&
    nodeCondition.hasUnit.length > 0 &&
    nodeCondition.hasUnit.every((u) => u.startsWith("not:"));
  return hasOnlyNegativeConditions ? DEFAULT_MATCH : NO_MATCH;
}
